import { FC } from 'react';
import styled from '@emotion/styled';
import { GemProduct } from 'src/types/Payments';
import GemProductItem from './GemProductItem';
import { SectionListWrapper, SectionHeaderRow as SectionHeaderRowBase, SectionTitle } from './styles';
const SectionHeaderRow = styled(SectionHeaderRowBase)`
  overflow: hidden;
`;
const ProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 16px;
`;
interface Props {
  gemProducts: GemProduct[];
  sectionTitle?: string;
  className?: string;
}
const GemProductList: FC<Props> = ({
  gemProducts,
  sectionTitle,
  className
}) => {
  if (gemProducts.length === 0) return null;
  return <SectionListWrapper className={className} data-sentry-element="SectionListWrapper" data-sentry-component="GemProductList" data-sentry-source-file="GemProductList.tsx">
      <SectionHeaderRow data-sentry-element="SectionHeaderRow" data-sentry-source-file="GemProductList.tsx">
        <SectionTitle data-sentry-element="SectionTitle" data-sentry-source-file="GemProductList.tsx">{sectionTitle}</SectionTitle>
      </SectionHeaderRow>
      <ProductsContainer data-sentry-element="ProductsContainer" data-sentry-source-file="GemProductList.tsx">
        {gemProducts.map(product => <GemProductItem key={product.productId} gemProduct={product} />)}
      </ProductsContainer>
    </SectionListWrapper>;
};
export default GemProductList;